import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { Game } from '@rct/lynx-lobbies-shared-lib';
import { Subscription } from 'rxjs';
import { LynxGameService } from '../../../services/game.service';

@Component({
    selector: 'lynx-game-search',
    templateUrl: './game-search.component.html',
    styleUrls: ['./game-search.component.scss'],
    standalone: false
})
export class GameSearchComponent implements OnInit, OnDestroy {
  @ViewChild('gameSection', { static: true }) gameSection: ElementRef;
  searchText: string;
  isShowOverlay: boolean;
  totalGames: Game[] = [];
  games: Game[] = [];
  subscription: Subscription = new Subscription();

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.close();
  }

  public close() {
    this.isShowOverlay = false;
  }

  constructor(
    private gameService: LynxGameService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getGames();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  inputValueChanged(text: string) {
    this.games = this.totalGames.filter((game: Game) => {
      return (
        !!text &&
        game.gameName.toLocaleLowerCase().startsWith(text.toLocaleLowerCase())
      );
    });
    this.cdr.detectChanges();
  }

  private getGames() {
    const sub = this.gameService.getSearchGames().subscribe((data) => {
      this.totalGames = data;
    });
    this.subscription.add(sub);
  }

  get isSearchEmpty() {
    return !!this.games && this.games.length === 0;
  }

  searchToggle() {
    this.clear();
    this.isShowOverlay = !this.isShowOverlay;
  }

  clear() {
    this.games = [];
    this.searchText = '';
  }
}
